export default {
  submitButton: {
    id: 'payment_form_submit_button',
    defaultMessage: 'Confirm and pay',
  },
}
